import {
	GetKYCInvestorInstanceRes,
	KYCFileType,
	SubjectAction,
} from '@dealstack/shared/lib/generated';
import {
	Step,
	StepType,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';

const STEP_TO_FILE_TYPE: Partial<Record<StepType, KYCFileType>> = {
	[StepType.PROOF_OF_IDENTITY]: KYCFileType.PROOF_OF_IDENTITY,
	[StepType.PROOF_OF_ADDRESS]: KYCFileType.PROOF_OF_ADDRESS,
};

export const isStepInherited = (
	step: Step,
	currentInvestor?: GetKYCInvestorInstanceRes
): boolean => {
	if (step.type === StepType.DECLARATIONS) {
		return (
			currentInvestor?.declarations?.some(
				(d) => d.subjectAction === SubjectAction.NOT_YET_ACTED
			) ?? false
		);
	}
	const fileType = STEP_TO_FILE_TYPE[step.type];
	if (!fileType) {
		return false;
	}
	return (
		currentInvestor?.kycFiles?.some(
			(f) =>
				!f.deleted && f.type === fileType && f.subjectAction === SubjectAction.NOT_YET_ACTED
		) ?? false
	);
};
